const testIds = {
  searchTerm: 'search-term',
};

export default testIds;
